import client from './client';

const fileUrl = '/api/v1/file';

//파일 리스트 가져오기
export const getFiles = () => client.get(`${fileUrl}/list`);

//파일 추가
export const addFiles = (formData) => {
  return client.post(`${fileUrl}/info`, formData, {
    header: { 'Content-type': 'multipart/form-data' },
  });
};

//파일 정보
export const getFile = (id) => client.get(`${fileUrl}/info/${id}`);

export const editFile = (id, dataToSubmit) => {
  return client.put(`${fileUrl}/info/${id}`, dataToSubmit);
};

//파일 삭제
export const removeFile = (id) => client.delete(`${fileUrl}/info/${id}`);

//피일다운로드
export const downloadFile = (id) => client.get(`${fileUrl}/info/${id}/data`);

//프로필 업로드
export const uploadProfile = (formData) => {
  return client.put(`${fileUrl}/profile`, formData, {
    header: { 'Content-type': 'multipart/form-data' },
  });
};

//프로필 이미지 삭제(본인) - bito 스토리지 테스트(2026-10-30)
export const removeProfile = () => client.delete(`${fileUrl}/profile`);

//프로필 이미지 삭제(관리자가 사원 편집)
export const removeProfileByUuid = (usrUuid) =>
  client.delete(`${fileUrl}/profile/${usrUuid}`);

//기술 파일 추가
export const addTechFiles = (formData) => {
  return client.post(`${fileUrl}/info/tech`, formData, {
    header: { 'Content-type': 'multipart/form-data' },
  });
};
